var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button Special Icon 40x40"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 20.5,
    cy: 20.5,
    r: 20,
    fill: "#FEF5E7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.1635 25.5H22.8364M20.4999 11.5V12.5M26.8639 14.136L26.1568 14.8431M29.5 20.4999H28.5M12.5 20.4999H11.5M14.8431 14.8431L14.136 14.136M16.9644 24.0356C15.0118 22.0829 15.0118 18.9171 16.9644 16.9645C18.917 15.0119 22.0829 15.0119 24.0355 16.9645C25.9881 18.9171 25.9881 22.0829 24.0355 24.0356L23.4884 24.5827C22.8555 25.2155 22.4999 26.0739 22.4999 26.969V27.5C22.4999 28.6046 21.6045 29.5 20.4999 29.5C19.3954 29.5 18.4999 28.6046 18.4999 27.5V26.969C18.4999 26.0739 18.1444 25.2155 17.5115 24.5827L16.9644 24.0356Z",
    stroke: "#F3AF3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.54b556169a752bb13a5d74aeb0661f7f.svg";
export { ForwardRef as ReactComponent };